export enum unitActionTypes {
  SET_UNITS = 'SET_UNITS',
  SET_UNITS_FILTERS = 'SET_UNITS_FILTERS',
  UNITS_LOADING = 'UNITS_LOADING',
  UNITS_FAILURE = 'UNITS_FAILURE',
  SET_UNITS_TOTAL = 'SET_UNITS_TOTAL',
}
